<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
        <div v-else>
            <component-header
                ref="headerComp"
                title="Customer"
                :enableOnClickSearch="true"
                @reload-data="reloadData"
                @create-press="$router.push({ path: '/customers/create' })"
                createButtonText="Onboard Customer"
                :hasCreate="true"
                :hasback="false"
                :hasDropdown="false"
                :hasSearch="false"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        style="border-radius: 12px"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :items="customers"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        thead-class="header"
                        class="mt-3"
                        :busy="loading"
                        show-empty
                        :fields="customerColumns"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                variant="primary"
                                v-b-tooltip.hover
                                title="Visitors"
                            >
                                <i class="fa fa-user"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                variant="primary"
                                v-b-tooltip.hover
                                title="View Customer"
                                @click="
                                    $router.push({
                                        name: 'ViewCustomer',
                                        params: { id: data.item._id },
                                    })
                                "
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                style="background: #fe7b08; border: #fe7b08"
                                variant="primary"
                                v-b-tooltip.hover
                                title="Edit Customer"
                                @click="
                                    $router.push({
                                        name: 'EditCustomer',
                                        params: { id: data.item._id },
                                    })
                                "
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                style="background-color: #660099"
                                v-b-tooltip.hover
                                title="Ticket"
                                @click="
                                    $router.push({
                                        name: 'RaiseTicket',
                                        params: {
                                            id: data.item._id,
                                            data: data.item,
                                            customerData: customersList.find(
                                                (cust) =>
                                                    cust._id === data.item._id,
                                            ),
                                        },
                                    })
                                "
                            >
                                <i class="fa fa-ticket"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                variant="danger"
                                v-b-tooltip.hover
                                title="Customer Termination"
                                @click="openTerminateModal(data.item._id)"
                            >
                                <i class="fa fa-close"></i>
                            </b-button>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="customers.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
        <b-modal
            ref="terminateModal"
            hide-footer
            centered
            title="Terminate Customer"
            size="md"
            class="termination-modal"
        >
            <div class="termination-content">
                <h2 class="text-danger text-center mb-4">
                    This action can't be revert!
                </h2>
                <div class="input-section">
                    <label for="reason" class="text-muted text-left d-block">
                        Please provide the reason for termination:
                    </label>
                    <b-form-textarea
                        id="reason"
                        v-model="terminateReason"
                        rows="3"
                        class="reason-input"
                        placeholder="Enter the reason here"
                    ></b-form-textarea>
                </div>
            </div>
            <div class="modal-footer justify-content-center mt-4">
                <div v-if="isLoading" class="spinner-overlay">
                    <div class="spinner"></div>
                </div>
                <b-button variant="danger" @click="hideTerminateModal">
                    Cancel
                </b-button>
                <b-button variant="danger" @click="confirmTerminate">
                    Terminate
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    components: {
        ComponentHeader,
        AtomSpinner,
    },
    data() {
        return {
            loading: false,
            filter: "",
            perPage: 10,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            fixed: false,
            currentPage: 1,
            loading: true,
            context: "Add",
            terminateReason: "",
            customerIdToTerminate: null,
            isLoading: false,
            customerColumns: [
                {
                    key: "customerNo",
                    label: "Customer Number",
                },
                {
                    key: "name",
                },
                {
                    key: "email",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            customersList: (state) => state.onboardCustomer.customerData,
        }),
        customers() {
            let data = this.customersList;
            const list = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let arrayObj = {
                        _id: obj._id,
                        customerNo: obj?.customerNo,
                        email: obj?.authentication?.email,
                        phone: obj?.authentication?.phone,
                        name: `${obj.name.first} ${obj.name.last}`,
                    };
                    list.push(arrayObj);
                });
                return list;
            } else {
                this.loading = false;
                return [];
            }
        },
    },
    methods: {
        reloadData() {
            this.fetchCustomerlist();
        },
        async fetchCustomerlist() {
            this.loading = true;
            await this.$store.dispatch(
                "onboardCustomer/fetchOnboardCustomerList",
            );
            this.loading = false;
        },
        openTerminateModal(customerId) {
            this.customerIdToTerminate = customerId;
            this.terminateReason = "";
            this.$refs.terminateModal.show();
        },
        hideTerminateModal() {
            this.$refs.terminateModal.hide();
        },
        async confirmTerminate() {
            this.isLoading = true;
            if (!this.terminateReason) {
                this.isLoading = false;
                this.$toasted.error("Please provide a reason for termination");
                return;
            }
            const payload = {
                customerId: this.customerIdToTerminate,
                reason: this.terminateReason,
            };
            try {
                await this.$store.dispatch(
                    "onboardCustomer/terminateCustomerAction",
                    payload,
                );
                this.isLoading = false;
                this.$toasted.success("Customer Terminated Successfully");
                this.hideTerminateModal();
                this.reloadData();
            } catch (error) {
                console.error("Error during termination:", error);
                this.$toasted.error("Termination Failed: " + error.message);
            } finally {
                this.isLoading = false;
            }
        },
    },
    mounted() {
        this.fetchCustomerlist();
    },
};
</script>
<style>
.termination-modal {
    max-width: 500px;
    border-radius: 15px;
    background-color: #f7f8fc;
    padding: 20px;
}
.termination-content {
    text-align: center;
}
.reason-input {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    margin-top: 10px;
    font-size: 1rem;
}
.input-section {
    margin-top: 20px;
}
label {
    display: block;
    margin-bottom: 8px;
    text-align: left;
}
.modal-footer {
    display: flex;
    justify-content: center;
}
.modal-footer .btn {
    width: 150px;
    margin: 0 10px;
}
.b-modal {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
}
.b-modal-header {
    border-bottom: none;
    text-align: center;
}
.b-modal-footer {
    border-top: none;
}
.b-modal-body {
    padding: 20px;
}
.modal-title {
    color: #0f0e0e;
    text-align: center;
}
.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
}
.spinner {
    border: 6px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
